import { type ComponentProps, forwardRef, type ReactNode } from 'react'

import { ActivityIndicator } from '../ActivityIndicator'
import type { ButtonPlain } from '../ButtonPlain'
import { Button } from './Button'
import { Label } from './Label'
import { LoaderWrapper } from './LoaderWrapper'

type Props = {
	label: ReactNode

	isLoading?: boolean
	isVisible?: boolean
	submit?: boolean
	renderLoader?: () => React.JSX.Element
} & Omit<ComponentProps<typeof ButtonPlain>, 'children' | 'type'>

export const ButtonLoading = forwardRef<HTMLButtonElement, Props>(
	(
		{
			label,

			isLoading = false,
			isVisible = false,
			disabled = false,
			renderLoader = () => <ActivityIndicator />,

			submit = false,

			...rest
		},
		ref,
	) => (
		<Button
			{...rest}
			ref={ref}
			disabled={disabled || isLoading || !isVisible}
			type={submit ? 'submit' : 'button'}
			isVisible={isVisible}
		>
			<LoaderWrapper isVisible={isLoading}>{isLoading && renderLoader()}</LoaderWrapper>

			{isVisible && (
				<Label isVisible={!isLoading} className='label'>
					{label}
				</Label>
			)}
		</Button>
	),
)
